import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/ticket-lifecycle/automations/{-$id}/{-$ruleIndex}')({
  beforeLoad: () => getTitleContextSlice('Ticket Workflows', { hideBreadcrumbs: true }),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
